
	import { LMap, LTileLayer, LMarker, LIcon, LPopup, LTooltip, LRectangle } from 'vue2-leaflet';
	import 'leaflet/dist/leaflet.css';
	//import 'leaflet.smooth_marker_bouncing'
	import L 						from 'leaflet';
	import io 						from 'socket.io-client';
	import { Icon } 				from 'leaflet';
	// import * as Vue2Leaflet from 'vue2-leaflet';
	import EventBus 				from '@/event-bus'
	import cam 						from "@/components/cam_test.vue"
	// import "leaflet.markercluster"
	import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'
	import record  					from '@/components/sounds/record.vue'
	import stateDevices 			from "@/components/StateDevices.vue"

	delete Icon.Default.prototype._getIconUrl;
	Icon.Default.imagePath = '.';
	/*Icon.Default.mergeOptions({
	  iconRetinaUrl : require('leaflet/dist/images/marker-icon-2x.png'),
	  iconUrl 		: require('leaflet/dist/images/marker-icon.png'),
	  shadowUrl 	: require('leaflet/dist/images/marker-shadow.png'),
	});*/

	
	/* 
	Setting for animation bounce
	Methods of L.Marker class */

	/*L.Marker.setBouncingOptions({
		bounceHeight : 60,    // height of the bouncing
        bounceSpeed  : 54,    // bouncing speed coefficient
        exclusive    : true,  // if this marker is bouncing all others must stop
	}); // sets options of bouncing of all markers*/
	// L.Marker.getBouncingMarkers();     // gets all bouncing markers
	// L.Marker.stopAllBouncingMarkers();
	// let LMarker = L.Marker;
	// console.log("MARKER ", LMarker)


	

	export default {
	  	name 		: 'mapview',
		components 	: {
		    LMap,
		    LTileLayer,
		    LMarker,
		    LIcon,
			LPopup,
			LTooltip,
			LRectangle,
			cam,
			'v-marker-cluster': Vue2LeafletMarkerCluster,
			record,
			stateDevices,
		}, // components
		props 		: [
			'edit',
			'info_to_component',
			'layout_id',
			'setting_to_map',
			'layout_end',
			'ref_to_component',
			'is_modal',
		],
		data 		: (vm) => ({
			map  			: null,
			url  			: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',// 'https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png',
			attribution 	: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
			// 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png',//
		    zoom 			: 8,
		    center 			: [47.313220, -1.319482],
		    marker  		: false, 
		    markers 	  	: [],
			marker_event  	: [],
			marker_static 	: [],
			maker_fit     	: [],
			police_icon   	: L.icon({
				iconUrl  : vm.$EXT + '/img/police.jpg', // 'https://www.flaticon.es/premium-icon/icons/svg/1183/1183400.svg',
				iconSize : [32, 37],
				iconAnchor : [16, 37]
			}),
			staticAnchor 	: [16, 37],
			customText 	 	: 'police',
			iconSize 	 	: 32,
			latitude 	 	: 0.0,
			longitude 	 	: 0.0,
			state 		 	: '',
			bounds 	 	 	: null,
		    list 		 	: [],
		    gps_active   	: true,		    
		    location 	 	: {},
		    locations    	: null,
		    setting_map 	: null,
		    info_option 	: { 
		    	mode 					: 'gps',
		    	country	 				: 'colombia',
		    	map 					: 'dark',
		    	name_map 				: "",
		    	devices_workstations 	: [],
		    	devices 				: [ 'all' ],
				names_devices 			: [ 'all' ],
				names_workstations 		: [],
				workstations 			: [],	
				zoom_in 				: 17,
				zoom_out 				: 15,
				time_zoom_out  			: 7,
		    }, 
		    head 			: {
		    	name_map : "",
		    },
		    list_modes      : [
		      	{
		        	key  : 'gps',
		        	text : 'gps',
		        	action : 'render_select',
		      	},
		      	{
		       		key  : 'devices',
		        	text : 'devices',
		        	action : 'render_select',		        
		      	},
		      	{
		      		key  : 'workstations',
		        	text : 'workstations',
		        	action : 'render_select',		        
		      	}
		      
		    ],
		    img_icon_gps  	: vm.$EXT + '/img/police.jpg', //https://www.flaticon.es/premium-icon/icons/svg/1183/1183400.svg
		    img_icon_static : vm.$EXT + '/img/tags/cam/active.png', //https://img2.freepng.es/20180629/arz/kisspng-camcorder-computer-icons-clip-art-puzzle-icon-5b35cdc7bd9852.4852279115302527437766.jpg
		    list_options : [
		    	{
		    		key   : 'mode',
					key_1   : "mode",		    		
		    		color : 'white',
		    		icon  : 'mdi-format-list-bulleted-type',
		    		list  : 'list_modes',
		        	action : 'render_select',
					key_text : "text",
		    		tooltip : "option",
		    		close_on_content : true,
		    		key_value : "key",
		    	},
		    	
		    	{
					key  				: "zoom",
					key_1   			: "zoom",
					color 				: "warning",
					icon 				: 'mdi-magnify-expand',
					class 				: "mx-2",
					tooltip				: "zoom_with_alerts",
					list 				: "list_zooms",
					action  			: "set_zoom",
					option 				: false,
					multiple 			: false,
					key_text 			: "name",
		    		close_on_content 	: false,
				},
		    	{
		    		
		    		key   : 'map',
					key_1   : "map",		    		
		    		color : 'primary',
		    		icon  : 'mdi-map-legend',
		    		list  : 'list_maps',
					key_text 	: "text",
		    		tooltip 	: "option",
					action 	  	: 'select_map',
		    		close_on_content : true,
		    		key_value : "key",
		    	},
		    	{
					key  	: "devices",
					key_1   : "names_devices",
					color 	: "primary",
					icon 	: 'mdi-devices',
					class 	: "mx-2",
					tooltip	: "devices",
					list 	: "list_devices",
					type 	: "list",
					action  : "set_device_group",
					option 	: false,
					multiple : true,
					key_text : "name",
		    		close_on_content : false,
		    		key_value : "deviceId",
				},
				{
					key  	: "workstations",
					key_1   : "names_workstations",
					color 	: "primary",
					icon 	: 'mdi-monitor',
					class 	: "mx-2",
					tooltip	: "workstations",
					type 	: "list",
					list 	: "list_workstations",
					action  : "set_workstations_group",
					option 	: false,
					multiple : true,
					key_text : "name",
		    		close_on_content : false,
		    		key_value : "manager_id",
				},
		    ],
		    
		    list_maps  		: [
			    {
		    		key 	  : 'default',
		    		text 	  : 'default',
		    		url_map	  : 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
					action 	  : 'select_map',
					attribution : '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
			
				},
				{ // this option its pay
		    		key 	  : 'dark',
		    		text 	  : 'dark',
		    		url_map	  : 'https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png',
					action 	  : 'select_map',
					attribution : 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png',
				},

		    ], 
		    geolocation 	: {
		    	latitude  : null,
		    	longitude : null,
		    },
		    show 			: {
		    	bar 				: true,
		    	name_map 			: true,
				edit_name_map 		: true,
				editing_name_map 	: false,
				close 				: true,
				mode 				: true,
				zoom 				: true,
				map 				: true,
				devices 			: true,
				workstations 		: true,
		    },
		    bus 	: {},
		   	mark_bounce : {
		   		marker 		: null,
		   		num_bounce  : 3,
		   		icon  		: "alert",
		   		timer 		: 1,
		   	},
		   	list_icons : {
		   		police 	: null,
		   		cam 	: null,
		   		active 	: null,
		   		off 	: null,
		   		alert 	: null,
		   	},
		   	icon_selected 	: null,
		   	alert_bus 		: true,
		   	is_marked 		: false,
		   	list_bouncing   : [],
		   	list_bouncing_   : [],
		   	is_map_ready    : false,
		   	ref_component   : null,
		   	icon_edit 		: null,		   	
			clusterOptions  : {
				chunkedLoading 				: true,
			    //spiderfyDistanceMultiplier 	: 4,
			    /*iconCreateFunction 			: cluster => {
	              let clusterUsers 	= cluster.getAllChildMarkers().map(marker => marker.id)
	              let clusterIconEl = new EnhancedClusterIcon({propsData: { clusterUsers }}).$mount().$el
	              return divIcon({
	                  html  	: clusterIconEl.outerHTML,
	                  className : 'cluster',
	                  iconSize 	: null
	              })
	          },*/
	            singleMarkerMode: false,
			          // icon : img_icon_gps
			    //spiderfyOnMaxZoom: true,
			    disableClusteringAtZoom: 15,
	      	}, 
		    streaming_active 	: {
		      	deviceId : "",
				close 	 : null 
			},
			pop_up_timers 		: {},
			info_comp 			: {
				list_no_show_bar : [ 
					"close",
					"redirect",
					"list_rois",
					"alert"
				]
			},
			ID_notification 	: "",
			first_event_device  : true,
			is_reload_devices   : true,
			list_workstations  	: vm.$store.getters['Workspaces/list_options'],
			list_devices 		: vm.$store.getters['Devices/list_options'],
			multiples  			: {				
				devices 		: [ "all" ],
				workstations 	: [ "all" ],
				mode 			: "devices",
				map 			: "dark"
			},
			list_zooms 			: [
				{
					type : "number",					
					key  : "time_zoom_out",
					text : vm.$ml.get("alert_display_time"), // zoom_out 
					action : "timer_zoom_out",
					slot_label : ' /seg',
				},
				{
					type : "slider",
					key  : "zoom_in",
					text : vm.$ml.get("zoom_in_alerted"), // zoom_in 
					action : "zoom_slider",

				},
				/*{
					type : "slider",					
					key  : "zoom_out",
					text : vm.$ml.get("zoom_out_after_alerted"), // zoom_out 
					action : "zoom_out",
				}*/
			],
			events 				: {
				timer_out 		: null,
				timeout_out 	: 8, // seg
				timer_out_2 	: null,
				zoom_out 		: 14,
				array 			: [],
				current 		: null,
				lat 			: null,
				long  			: null, 
				is_shorting 	: false,
				time_short  	: 3.5, // seg
				array_devices 	: [],
			},

			rectangle: {
			    bounds: [[85.17766, -179.99999], [-87.17766, 179.99999]],
			    limit_long : [-179.99999, 179.99999],
			    style: { color: 'blue', weight: 3 },
			    bounds_LT : null,
			    max 	: 50,
			    min  	: 2,
			},
			do_zoom  			: {},
			info_map_devices  	: {},
			mode_active 		: "devices", 
			loading 			: false,

		}), // data

		created(){
			const route_name = this.$route && this.$route.name ? this.$route.name : "";
			this.render_icons();
			if (this.layout_id) {
				this.ID_notification = this.layout_id;	
			}
			
			let temp_map = this.$Helper.get_local('map_selected');
			if (temp_map) {
				this.url 			 = temp_map.url_map;
	  			this.info_option.map = temp_map.key;
			}

			if (this.setting_to_map) {
				this.setting_map = this.setting_to_map;
			}
			if (this.ref_to_component) {
				this.ref_component = this.ref_to_component;
			}
			this.render_setting_map();
			
			
			/*if (this.gps_active) {
				EventBus.$emit('start_gps', true);
			}*/
			
			if (this.info_to_component) {

				let temp 	= this.info_to_component && this.info_to_component.locations ?  this.info_to_component.locations : [];
				let devs 	= this.$Helper.get_local('list_devices');
				// let devs1 	= this.$store.getters()								
				if (route_name.includes('dashboard') && this.layout_id && 
					this.layout_id.includes('mapview') && devs && devs.length > 0) {
					temp = devs;
				}				

				this.render_info(temp);				
				this.is_marked = true;				

				if (this.info_to_component.info_option || this.info_to_component.multiples) {
					this.$nextTick(()=>{
						this.actions("load_component", this.info_to_component);
					});
				}else{
					if (!route_name.includes("setting_device")) {						
						this.$nextTick(()=>{
							this.render_default_multiples();
							this.render_locations();
						})
					}else{						
						this.multiples.workstations = ['all'];
						this.multiples.devices 		= [ 'all'];
						this.multiples.mode 		= "edit";
						this.info_option.mode 		= "edit";
						this.info_option.map 		= "dark";
						this.multiples.map 			= "dark";
					}
				}
			}

			if (this.list_icons && this.list_icons[this.mark_bounce.icon]) {
	    		this.render_set_icon(this.mark_bounce.icon);
	    		this.icon_edit = this.render_set_icon('active', "icon_return");
	    	}
	    	if (this.edit) {
	    		this.show.close 		= false;
	    		
	    	}
	    	if (route_name.includes("dashboard")) {
	    		let modul = this.$store.getters["auth/permission"]("dashboard");
	    		// console.log("modul mapview ",modul)
	    		if (!modul.can_edit) {
	    			this.show.close 		= false
					// this.show.mode 			= false
					this.show.zoom 			= false
					// this.show.map 			= false
					this.show.devices 		= false
					this.show.workstations  = false;
	    		}else{
	    			this.show.close 		= true

	    		}
	    	}else{
	    		if (route_name.includes("setting_device")) {
	    			this.rectangle.min = 1;
	    		}
	    	}
		}, // created 

		watch: {
			info_to_component: function (val){
				if (val) {
					// this.render_info(val);
				}
			}, // info to component
			
			layout_end : function(val){
				this.onResize();
			}, // layout end

			"info_option.zoom_in" : function(val){
				if (val) {
					this.actions("zoom_slider", val);
					this.doZoom(val);
				}
			}, // 
			
			"info_option.time_zoom_out" : function(val){
				if (val) {
					this.actions("zoom_slider", val);
				}
			}

		}, // watch

		computed: {
			dynamicSize () {
				return [this.iconSize, this.iconSize * 1.15];
			},
			dynamicAnchor () {
				return [this.iconSize / 2, this.iconSize * 1.15];
			},
			currentUser() {
		      return this.$store.state.auth.user;
		    },
		    listSmartEvents(){
		    	return this.$SmartEvent.getListSmartEvent();
		    }
		}, // computed

	  	methods: {

	  		actions(act, item, opt){
	  			// console.log("Action map : ", act, item);
	  			if (act == 'render_select') {
	  				this.render_select(item);
	  				this.setting_map.gps_inactive = item.key == 'gps' ? false : true;
	  				// this.$Helper.set_local('settings_map', {...this.setting_map});
					this.actions("update_component");

	  			}
	  			if (act == 'zoom_select') {
	  				if (item && item.latitude &&  item.longitude) {
						// this.marker = L.latLng(item.latitude, item.longitude);	  					
						this.center = L.latLng(item.latitude, item.longitude);
						this.zoom   = item.zoom;
						this.onResize();
	  				}else{
	  					console.warn("Not found item or location for zoom")
	  				}

	  			}
	  			if (act == 'select_map') {
	  				if (item) {
	  					this.url 			 = item.url_map;
	  					this.attribution 	 = item.attribution
	  					this.info_option.map = item.key;
	  					this.$Helper.set_local('map_selected', item);
	  				}
	  			}
	  			if (act == "set_device_group") {
					if (item && item.deviceId) {						
						this.$nextTick(()=>{
							// console.log("multiples ", this.multiples.devices.length)
							if (this.info_option && this.info_option.devices) {

								if (this.info_option.devices.includes(item.deviceId)) {
									let idx = this.info_option.devices.findIndex(x => (x && x == item.deviceId));
									if (idx >= 0) {
										this.info_option.devices.splice(idx, 1);
										this.info_option.names_devices.splice(idx, 1);

									}
								}else{
									this.info_option.devices.push(item.deviceId);						
									this.info_option.names_devices.push(item.name);
								}		
							}	
							if (this.multiples && this.multiples.devices && this.multiples.devices.length > 0) { 

								if (item.deviceId == "all") {
									if (this.multiples.devices.includes(item.deviceId)) {
										this.multiples = {
											...this.multiples,
											devices 		: this.list_devices.map(x => x.deviceId ),
											workstations 	: this.list_workstations.map(x => x.manager_id),
										};
									}else{
										this.multiples = {
											...this.multiples,
											devices 		: [],
											workstations 	: [],
										};
									}
								}else{
									if (this.multiples.devices.includes("all")) {
										this.multiples.devices.splice(this.multiples.devices.indexOf('all'),1) 
									}
									const dev = {...item};
									if (dev) {
										let temp_devices =  this.list_devices.filter(x =>{
											if (x.manager_id == dev.manager_id && this.multiples.devices.includes(x.deviceId)) {
												return true;
											}else if (!x.manager_id && !dev.manager_id && this.multiples.devices.includes(x.deviceId)) {
												return true;												
											}
											
										}).map(z => z.deviceId);
										if (!this.multiples.devices.includes(item.deviceId)) {
											// temp_devices.filter(z => this.multiples.devices.incl)
											if (temp_devices && temp_devices.length === 0 && this.multiples && this.multiples.workstations && this.multiples.workstations.length > 0) {
												if (!dev.manager_id) {
												// console.log("CHECK clear ", temp_devices,dev.manager_id,  this.multiples.workstations.indexOf("my_computer"));
													this.multiples.workstations.splice(this.multiples.workstations.indexOf("my_computer"),1);
												}else{
													this.multiples.workstations.splice(this.multiples.workstations.indexOf(dev.manager_id), 1);
												}
												if (this.multiples.workstations.includes("all")) {
													this.multiples.workstations.splice(this.multiples.workstations.indexOf('all'),1);
												}
											}else if(!this.multiples.workstations.includes(dev.manager_id)){
												// console.log("ADD to workstations")
												if (!dev.manager_id) {
													if (!this.multiples.workstations.includes("my_computer")) {
														this.multiples.workstations.push("my_computer");
													}
												}else{
													if (!this.multiples.workstations.includes(dev.manager_id)) {
														this.multiples.workstations.push(dev.manager_id);
													}
												}
											}
										}else{
												// console.log("ADD to workstations 2", dev.manager_id, this.multiples.workstations.includes(dev.manager_id))
											if(!this.multiples.workstations.includes(dev.manager_id)){
												if (!dev.manager_id) {
													if (!this.multiples.workstations.includes("my_computer")) {
														this.multiples.workstations.push("my_computer");
													}
												}else{
													if (!this.multiples.workstations.includes(dev.manager_id)) {
														this.multiples.workstations.push(dev.manager_id);
													}
												}
											}
										}
									} // dev 

										// console.log("this.multiples", this.multiples)  
								}
							}else {
								this.multiples = {
									...this.multiples,
									devices 		: [],
									workstations 	: [],
								};
							}
							if (this.mode_active == "workstations") { // reactivate in mode workstations 
		    					this.render_map_gps_workstations();
		    				}
							this.render_locations();													
							this.actions("update_component");
						}); // nextTick
					}
				}else 
				if ( act == "set_workstations_group" ){
					if (item && item.manager_id) {						
						/*if (this.info_option && this.info_option.workstations) {
							if (this.info_option.workstations.includes(item.manager_id)) {
								let idx = this.info_option.workstations.findIndex(x => (x && x == item.manager_id));
								if (idx >= 0) {
									this.info_option.workstations.splice(idx, 1);
									this.info_option.names_workstations.splice(idx, 1);

								}
							}else{
								this.info_option.workstations.push(item.manager_id);						
								this.info_option.names_workstations.push(item.name);
							}		
						}	*/

						this.$nextTick(()=>{
							if (this.multiples && this.multiples.workstations && this.multiples.workstations.length > 0) { 
								// case 1  multiples  == all
								if (item.manager_id == 'all' ) {
									if (this.multiples.workstations.includes(item.manager_id)) {
										// console.log("ALL select includes")
										this.multiples= {
											...this.multiples,
											devices 		: this.list_devices.map(x => x.deviceId),
											workstations 	: this.list_workstations.map(x => x.manager_id)
										};
									}else{
										// console.log("ALL select Not includes")

										this.multiples = {
											...this.multiples,
											devices 		: [],
											workstations 	: []
										};
									}
								}
								else if(item.manager_id){ // case 2 multiples 
									if (this.multiples.workstations.includes(item.manager_id)) {
										// console.log(" select includes workstations", item.manager_id)
										let temp_devices = []; 
										this.list_devices.forEach(x =>{
											if (x.manager_id == item.manager_id || (!x.manager_id && item.manager_id == 'my_computer')) {
												temp_devices.push(x.deviceId);
											}
										})
										// temp_devices = this.multiples.devices.concat(temp_devices);
										this.multiples = {
											...this.multiples,
											devices 		: [ ...this.multiples.devices, ...temp_devices],										
										};
									}else{
										if (this.multiples.workstations.includes("all")) {
											this.multiples.workstations.splice(this.multiples.workstations.indexOf('all'),1) 
										}										
										const valid = [] 
										this.list_devices.forEach(z => { 
											if ((item.manager_id == z.manager_id) || (item.manager_id == 'my_computer' && !z.manager_id)){
												valid.push(z.deviceId)										
											}
										});
										// console.log("valid ", valid)	
										this.multiples.devices = this.multiples.devices.filter(x => !valid.includes(x)) 
									}	
								}

							}else { // case 3 multiple == 0
								this.multiples = {
									...this.multiples,
									devices 		: [],
									workstations 	: []
								};
							}
							this.render_locations();
							this.actions("update_component");
		    				if (this.mode_active == "workstations") { // reactivate in mode workstations 
		    					this.render_map_gps_workstations();
		    				}

						}); // nextTick
					}
				}else
				if (act == "update_component") {
					if (this.layout_id) {
						this.$emit('update_of_component',{
							component : "mapview",
							value 	  : { 							
								info_option : { ...this.info_option },
								multiples 	: { ...this.multiples }, 
								locations   : [ ...this.locations ],
								setting_map : {...this.setting_map},
								info_map_devices : { ...this.info_map_devices },
							},
							ID 		  : this.layout_id,
						});
					}
				}else
				if ( act == "load_component" ) {
					// console.log("Load components map : ", item)
					if (item) {
						if (item.multiples) {														
							this.multiples 			= { ...item.multiples };
						}
						if (item.info_option) {
							this.info_option 	= { ...item.info_option };												
							if (this.info_option.devices && this.info_option.devices.length > 0 ) {
								this.multiples.devices 		= [ ...this.info_option.devices ];
								this.info_option.devices 	= []; 	
							}
							if (this.info_option.workstations && this.info_option.workstations.length > 0) {
								this.multiples.workstations 	= [ ...this.info_option.workstations ];
								this.info_option.workstations 	= []; 	
							}

							if (item.info_option.map){
								this.multiples.map = this.info_option.map;
							}
							if (item.info_option.mode) {
								this.multiples.mode = this.info_option.mode; 
							}

							
						}
						if (this.multiples && this.multiples.devices.some(x => x == "all") && this.multiples.workstations.some(x => x == "all") && 
							this.multiples.devices.length == 1 && this.multiples.workstations.length == 1
							) {

							this.$nextTick(()=>{
								this.render_default_multiples();
							}); // nextTick
						}
						if (item.info_map_devices) {
							this.info_map_devices = { ...item.info_map_devices };
						}
						if (item.setting_map) {
							this.setting_map 	 = {...item.setting_map};
							this.$nextTick(()=>{
								// this.multiples.mode  = "";
								// console.log("setting_map ", this.setting_map);
								/*let temp_mode = this.setting_map.gps_inactive  ? "devices" :  "gps";
								temp_mode     = this.info_option.mode;*/								
								this.render_select({ key : this.info_option.mode});
								this.render_setting_map();
							})
						}
						this.$nextTick(()=>{
							this.render_locations();
						})
					}
				}else
				if ( act == "edit_name_map" ) {
					this.show.editing_name_map = true;

				}else
				if ( act == "save_name_map") {
					this.show.editing_name_map = false;

					this.actions("update_component");
				}else
				if (act == "zoom_slider") {
					console.log("change", item)
					this.actions("update_component");

				}else
				if (act == "zoom_in") {
					if (opt == 'minus') {
						this.info_option.zoom_in--;
					}else{
						this.info_option.zoom_in++;						
					}
					this.actions("update_component");

				}else 
				if (act == "zoom_out") {
					if (opt == 'minus') {
						this.info_option.zoom_out--;
					}else{
						this.info_option.zoom_out++;						
					}
					this.actions("update_component");

				}else 
				if (act == "refresh_cluster"){
					if (this.$refs && this.$refs['clusterRef' + this.layout_id].mapObject) {
						this.$refs['clusterRef' + this.layout_id].mapObject.refreshClusters();
					}
					// console.log("check", this.$refs['clusterRef' + this.layout_id].mapObject)
						/*this.$refs['clusterRef' + this.layout_id].on('clusterclick', (a)=>{
	      		console.log("layer ", a)
	      		console.log("ev.$refs[ref_temp][0].mapObject", this.$refs['clusterRef' + this.layout_id][0], markers)
	      	})*/
				}

	  		}, // actions

	  		check_long(item){
	  			if (item) {	  					  				
	  				// limit left -179
	  				// console.log("check ", item)	  				 
	  				
	  				if (item < this.rectangle.limit_long[0] && [-1, -0].includes(Math.sign(item))) {	  					
	  					item = (parseFloat(item) + parseInt(this.rectangle.limit_long[1])) + parseInt(this.rectangle.limit_long[1]) ;	  					
	  				}
	  				// limit rigth 179
	  				if (item > this.rectangle.limit_long[1] && [1, 0].includes(Math.sign(item))) {	  					
	  					item = (parseFloat(item) - parseInt(this.rectangle.limit_long[1])) -  parseInt(this.rectangle.limit_long[1]);	  					
	  				}
	  				if ((item < this.rectangle.limit_long[0] && [-1, -0].includes(Math.sign(item))) || (item > this.rectangle.limit_long[1] && [1, 0].includes(Math.sign(item)))) {
	  					item = this.check_long(item);
	  				}
	  				// console.log("check 2", item,  (item < this.rectangle.limit_long[0] && [-1, -0].includes(Math.sign(item))) || (item > this.rectangle.limit_long[1] && [1, 0].includes(Math.sign(item))))	  				 

	  			}
	  			return item;
	  		}, // check long

	  		render_default_multiples(){	  				  			
	  			if (this.multiples.workstations) {
					this.multiples.workstations = ['all'];
					this.multiples.workstations = this.list_workstations.map(x => x.manager_id);					
				}
				if (this.multiples.devices) {
					this.multiples.devices 		= [ 'all'];
					this.multiples.devices 		= this.list_devices.map(x => x.deviceId);

				}
				this.info_option.mode 	= "devices";
				this.multiples.mode   	= "devices";				
				this.info_option.map 	= "dark";
				this.multiples.map 		= "dark";	  			
	  		}, // render default multiples

	  		render_info(item){
	  			if (item) {

	  				if (item.length > 0) {
	  					this.locations = [];
	  				}else{
	  					console.log("Not found property length for render locations : ", item);
	  				}
	  				this.locations = item;
	  				if (this.is_map_ready){
	  					this.render_locations();
	  				}

	  			}else{	
	  				console.log("Not exist item locations : ", item);
	  			}
	  		}, // render info 

	  		render_listed(val){
	  			if (this[val]) {
	  				return this[val];
	  			}

	  		}, // render listed

	  		render_icons(){
	  			if (this.list_icons) {
	  				for( let icon in this.list_icons){
	  					if (["police", "cam"].includes(icon)) {
		  					this.list_icons[icon] =  L.icon({
								iconUrl  : this.$EXT + `/img/${icon}.jpg`, // 'https://www.flaticon.es/premium-icon/icons/svg/1183/1183400.svg',
								iconSize : [32, 37],
								iconAnchor : [16, 37]
							});

	  					}else{
	  						this.list_icons[icon] =  L.icon({
								iconUrl  : this.$EXT + `/img/tags/cam/${icon}.png`, // 'https://www.flaticon.es/premium-icon/icons/svg/1183/1183400.svg',
								iconSize : [32, 37],
								iconAnchor : [16, 37]
							});

	  					}
	  				}
	  			}
	  		}, // render icons

	  		render_set_icon(icon, type = 'icon', opt){
	  			if (type == 'img') {
	  				let path = '/img/';
	  				let ext  = '.jpg';
	  				if (!["police", "cam"].includes(icon)) {
	  					path = '/img/tags/cam/';
	  					ext  = '.png';
	  				}

		  			if (opt == 'gps') {
		  				this.img_icon_gps =  this.$EXT + path + icon + ext;

		  			}if (opt == 'static') {
		  				this.img_icon_static = this.$EXT + path + icon + ext;
		  			}
	  			}
	  			else	
  				if (type == 'icon' && this.list_icons && this.list_icons[icon]) {
  					
  					this.icon_selected = this.list_icons[icon];
  				}else if (type == 'img_return') {
  					let path = '/img/';
	  				let ext  = '.jpg';
	  				if (!["police", "cam"].includes(icon)) {
	  					path = '/img/tags/cam/';
	  					ext  = '.png';
	  				}
	  				return  this.$EXT + path + icon + ext;
  				}else if (type == 'img_return') {
  					let path = '/img/';
	  				let ext  = '.jpg';
	  				if (!["police", "cam"].includes(icon)) {
	  					path = '/img/tags/cam/';
	  					ext  = '.png';
	  				}
	  				return  this.$EXT + path + icon + ext;
  				}else if (type == 'icon_return' && this.list_icons && this.list_icons[icon]) {

  					return this.list_icons[icon];
  				}
	  		}, // render set icon

	  		render_setting_map(){
				let temp = null;
				if (this.setting_map) {
					temp = this.setting_map;
				}
				/*else{
					temp = this.$Helper.get_local("settings_map");
				}	*/			
				// console.log("render_setting_map", temp)
	  			if (temp && this.setting_to_map) {
					const { hide_bar, gps_inactive } = temp; 
					if (hide_bar) {
						this.show.bar = false;
					}
					// console.log("CHECKing render setting_map  ", hide_bar, gps_inactive, this.info_option, this.setting_to_map)
					if (gps_inactive) {
						this.gps_active 		= false;
						this.info_option.mode 	= 'devices';
						if (this.$route && this.$route.name && this.$route.name.includes("setting_device") ) {
							this.info_option.mode = "edit";
						}
					}else{
						this.gps_active 		= true;
						this.info_option.mode 	= 'gps';
					}
					this.setting_map = temp;
				}else{
					this.setting_map = {
						hide_bar 	 : false,
						gps_inactive : false,
					}
				}
	  		}, // render setting map

	  		render_bounds(){
	  			let ev = this;
	  			if (ev.maker_fit && ev.maker_fit.length > 0) {
	  				const timer = setTimeout(()=>{
						let bounds = new L.LatLngBounds(ev.maker_fit);
						console.log("BOuNDS ", bounds)
						if (ev.map && bounds){
							try{
								ev.map.fitBounds(bounds);		
							}catch(error){
								console.warn("Error bounds map ", error)
							}
							/*let bounds1 = new L.LatLngBounds(new L.LatLng(49.5, -11.3), new L.LatLng(61.2, 2.5));
							ev.map.maxBounds= bounds1;
  							ev.map.maxBoundsViscosity= 0.75*/								
							ev.events.zoom_out = this.map._zoom;	
							if (ev.is_reload_devices) {
								ev.is_reload_devices = false;
								ev.render_locations();
							}				
						}else{
							console.warn("Not editable , Not found some property : ", bounds)
						}
						clearTimeout(timer);
	  				}, 850)
				}
	  		}, // render bounds

    		doSomethingOnReady() {
    			let vm = this;
    			this.$nextTick(() => {
	        		this.map = this.$refs.myMap.mapObject;
	        		// console.log("MAP ", this.map)
	        		// this.rectangle.bounds_LT = new L.LatLngBounds(L.LatLng(85.17766, -179.99999),L.LatLng(-87.17766, 179.99999));
	        		// console.log("MAP : ",this.$refs.myMap);
	        		this.is_map_ready = true;
	        		this.render_locations();
	        		 // this.$refs.myMap.mapObject.ANY_LEAFLET_MAP_METHOD();
	        		vm.onResize();
	        	}); // nextTick
	    	}, // doSomethingOnReady

	    	onResize() {
				// this.$refs.map.mapObject.invalidateSize();
				// this.$refs.map.mapObject.invalidateSize();

				const resize_time = setTimeout(function() { 
					window.dispatchEvent(new Event('resize'));
					clearTimeout(resize_time);
      		 	}, 250);
			}, // on resize

			removeMarker(index) {
				if(this.edit) {
					// console.log("remove marker ", index);

					this.marker_static.splice(index, 1);
					this.send_location("", "");

				}
			},
			addMarker(event) {
				// console.log("ADD marker ", event);
		    	if(this.edit) {
					this.marker_static.splice(0, 1);
					this.marker_static.push({
						latln : L.latLng(event.latlng.lat, event.latlng.lng),
						name  : "latitude:" + (event.latlng.lat).toFixed(5) + " longitude: " + (event.latlng.lng).toFixed(5),
						icon  : this.icon_edit,
						marker  : null,
						show 	: true,
						info_alert: { img : this.$logos.no_img_found},
						state : 1,
					});
					// console.log(event.latlng)
					this.send_location(event.latlng.lng, event.latlng.lat)
				}
			},
		    send_location(long = 0, lat = 0){
		    	let location = {
		    		latitude  : lat,
		    		longitude : long,
		    	}
		    	this.$emit('recive_location', location);
		    }, // send location

		    
		    render_locations(){
		    	let ev = this;
		    	// Add to map markers 
				let icon  	 	= this.render_set_icon("off", "icon_return");//this.icon_selected;				
		    	if(this.locations && this.edit){ // for edit							    		
					if (this.locations.latitude && this.locations.longitude && this.edit ){
						const long 		= this.check_long(this.locations.longitude);

						let info_dev 	= { channel : "WebRTC 2" };
						if (ev.info_map_devices && ev.info_map_devices[this.locations.deviceId]) {
							info_dev  = ev.info_map_devices[this.locations.deviceId];	
						}
						ev.marker_static = [];						
						ev.marker_static.push({
							latln 		: L.latLng(this.locations.latitude, long),
							name  		: "latitude : " + (parseInt(this.locations.latitude)).toFixed(5) + " longitude : " + (parseInt(long)).toFixed(5),
							img_icon  	: this.img_icon_static,
							icon 		,
							...info_dev
						})
						ev.maker_fit.push(L.latLng(this.locations.latitude, long));
						ev.render_bounds();
					}
				}else if (!this.gps_active){
					if (this.geolocation && this.geolocation.latitude && this.geolocation.longitude ) {
						this.actions('zoom_select', this.geolocation);
					}
				}													
		    	if(!this.edit && (this.info_option.mode == 'devices' || this.is_modal) ) {					
		    		let lat, long;
					this.alert_bus 	= true;
					this.maker_fit 	= [];
					this.info_option.devices_workstations = [];
					if (this.locations && this.locations.length > 0) {												
						let temp_locts 	= [];
						this.loading = true ;
						this.locations.forEach((location, index_a, array)=> {		
						// console.log("CHECK ==== ", ev.check_device_workstation(location))							    				
							if (location && location.latitude && location.longitude && ev.check_device_workstation(location)) {
								let long = ev.check_long(location.longitude);
								let info_dev = ev.info_map_devices && ev.info_map_devices[location.deviceId] ? ev.info_map_devices[location.deviceId] : { channel : "WebRTC 2"};
								ev.info_option.devices_workstations.push(location.deviceId);
								ev.maker_fit.push(L.latLng(location.latitude, long))
								
								temp_locts.push(
									{
										latln 	 	: L.latLng(location.latitude, long),
										name 	 	: location && location.name ? location.name : 'Device',
										deviceId 	: location && location.deviceId ? location.deviceId : null,
										icon 	 	,
										marker   	: null,
										show 	 	: true,
										info_alert 	: { img : ev.$logos.no_img_found},
										// deviceId   	: location.deviceId, 
										state 		: 0, // 1 active, 0 off , 2 alert
										img_icon    : ev.img_icon_static,
										...location, 
										...info_dev 

								});

							
								// ev.markers.addLayer(L.marker([lat, long]).addTo(ev.map));
								// L.marker([lat, long], {icon}).addTo(ev.map);
							}
							if (array.length - 1 == index_a) {
								ev.marker_static = temp_locts;
								ev.render_bounds();
								this.loading = false ;

														
														// console.log("CHAGE MAP ", temp_locts)
								// ev.map.addLayer(ev.markers);
							}
						})			
					}
				}else if (!this.edit && this.info_option.mode == 'workstations') {
					let lat, long;
					this.alert_bus 	= true;
					this.maker_fit 	= [];
					this.marker_static = [];

					// this.info_option.devices_workstations = [];
					// console.log("RENDER Workstation ", this.list_workstations)
					let temp_locts 	= [];
					// const
					if (this.multiples && this.multiples.length > 0 && this.multiples.workstations && this.multiples.workstations.length > 0) {	
						this.loading = true ;															
						this.list_workstations.forEach((location, index_a, array)=> {							
							if (location && location.latitude && location.longitude && ev.check_device_workstation(location)  &&
								(this.multiples.workstations.includes('all') || this.multiples.workstations.includes(location.manager_id))
							/*|| location.manager_id == 'my_computer'*/) {
								// location.latitude = 47.28113;
								// location.longitude = -0.96936;
								let long = ev.check_long(location.longitude);

								let temp = ev.format_workstation(location, long);
								// ev.info_option.devices_workstations.push(location.deviceId);
								ev.maker_fit.push(L.latLng(location.latitude, long))
								temp_locts.push(temp);

							
								// ev.markers.addLayer(L.marker([lat, long]).addTo(ev.map));
								// L.marker([lat, long], {icon}).addTo(ev.map);
							}
							if (array.length - 1 == index_a) {
								ev.marker_static = temp_locts;
								// console.log("CHECK temp ", temp_locts)
								ev.render_bounds();
								this.loading = false ;

														
								// ev.map.addLayer(ev.markers);
							}
						})			
					}
				}
				else if(this.info_option.mode == 'devices'){
					this.alert_bus = false;
				}
				this.$nextTick(()=>{
					EventBus.$emit("getListTechnicals");
				});
		    }, // set locations

		    format_workstation(location, long){
				let info_dev = [];
				// console.log("CHECK location FORMAT ", location.manager_id)
		    	if (this.list_devices && this.list_devices.length > 0 && this.multiples && this.multiples.devices && this.multiples.devices.length > 0 ) {									
					this.list_devices.forEach((it)=>{
						if (it && (this.multiples.workstations.includes(it.manager_id) || 
							(!it.manager_id && this.multiples.workstations.includes('my_computer') && location.manager_id == 'my_computer')) && (this.multiples.devices.includes(it.deviceId) || this.multiples.devices.includes('all'))) {
							
							if (it.deviceId != 'all') {
							// console.log("ADD DEVICE ", it)
								info_dev.push({ 
									channel  	: "WebRTC 2",
									deviceId 	: it.deviceId,
									manager_id  : it.manager_id,
									name 		: it.name,
									rtsp 		: it.rtsp,
									rtsp2		: it.rtsp2,
									id 			: it.id,
								})
							}
							// }
						}
					})
								
				}				
				return {
					latln 	 	: L.latLng(location.latitude, long),
					name 	 	: location && location.name ? location.name : 'Workstation',
					deviceId 	: location && location.deviceId ? location.deviceId : null,
					manager_id  : location.manager_id,
					icon 	 	: this.render_set_icon("off", "icon_return"),
					marker   	: null,
					show 	 	: true,
					info_alert 	: { img : this.$logos.no_img_found},									
					state 		: 0, // 1 active, 0 off , 2 alert
					img_icon    : this.img_icon_static,
					devices 	: info_dev, 

				}
		    }, // format_workstation

		    render_select(item){
		    	if (item) {
		    		this.info_option.mode = item.key;
		    		this.multiples.mode   = item.key;
		    		if (item.key == 'gps') {
		    			this.gps_active = true;
		    			EventBus.$emit('start_gps', true);
		    		}else{
		    			this.gps_active = false;
		    		}
		    		if (item.key == 'devices') {
		    			this.render_locations();
		    		}
		    		if (item.key == "workstations") {
		    			this.render_locations();
		    			this.render_map_gps_workstations();
		    		}else{
		    			if (this.mode_active == "workstations") {
    						this.$Helper.clear_bus(EventBus, this.bus, 'mapview');
		    			}
		    		}
		    		this.mode_active = item.key;

		    	}else{
		    		console.log("Not found select : ", item);
		    	}
		    }, // render select

		    clear_map(){
		    	if (this.marker_static && this.marker_static.length > 0) {
		    		let vm 				= this;
		    		vm.marker_static 	= [];		    		
		    	}
		    }, // clear map

		    set_state_stream(idx, state){
		    	let icon 		= 'off';
		    	if (state == 1) {
		    		icon = 'active'
		    	}
		    	if (state == 2) {
		    		icon = "alert";
		    	}
		    	if (idx >= 0 && this.marker_static && this.marker_static[idx]) {
					this.marker_static[idx].state 	= state;				
					let temp 					= this.render_set_icon(icon, "icon_return");
					
					if (temp) {
						if(this.marker_static[idx]){
							if (!this.events.is_shorting) {
								// console.log("list_icons ", this.list_icons[icon], this.marker_static[idx], temp )
								// const temp_dev = {...this.marker_static[idx]};
								// const temp_list_devs = [...this.marker_static];
								// this.marker_static = [];
								// temp_dev.icon = temp;
								
									// this.marker_static.splice(idx, 0, temp_dev);
								
								// temp_dev.icon = this.list_icons[icon];
								// temp_list_devs.splice(idx, 1, temp_dev);
								// temp_list_devs.forEach((it)=>{
									// this.$nextTick(()=>{
								try{
									// this.marker_static = [...temp_list_devs];//.push(it); 
									this.marker_static[idx].icon 	= temp;
									this.actions("refresh_cluster")
								}catch(er){
									console.warn("error set devs ", er)
								}
								// })
								// const markerCluster = this.$refs['clusterRef' + this.layout_id];
							      // if (markerCluster) {
							        // const map = markerCluster.mapObject;
							        // const latitud = this.marker_static[idx].latln.lat;
							        // const longitud = this.marker_static[idx].latln.lng; 

							        
							        // Busca el marcador por sus coordenadas
							        /*map.eachLayer(layer => {
							        	console.log("layer ", layer)
							          if (layer instanceof L.Marker && layer._latlng.lat === latitud && layer._latlng.lng === longitud) {
							            // Elimina el marcador del clúster
							            // markerCluster.removeLayer(layer);
							            markerCluster.options.icon = temp;
							          }
							        });*/
								// }
							}
						}
					}
		    	}
		    }, // set state stream

		    event_alert(message){
		    	// this.info_option.zoom_in || 15
		    	if (this.events) {
		    		if (this.events.array && this.events.array.length > 0) {		    			
		    			this.short_event(message);
		    			// console.log("short_event", this.events.array.length)
		    		}else{
		    			this.events.array_devices.push(message.deviceId);			    		    			
			    		this.events.array.push(message);
		    			this.render_event_alert(message);
		    			// console.log("render event", this.events.array.length)
		    			
		    		}
		    	}

		    }, // event alert

		    short_event(message){
		    	if (this.events) {
					// console.log("ALERt timer ", this.events.timer_out)
			    	if (!this.events.is_shorting) {		

			    		// console.log("short_event ", this.events.is_shorting)
			    		if (this.events.current && this.events.current.deviceId != message.deviceId)  {		
			    			// console.log("case 1 short_event")

			    			this.events.array_devices.push(message.deviceId);			    		    			
			    			this.events.array.push(message);
			    			this.events.is_shorting = true;
							if (this.events.timer_out) {
		  						clearTimeout(this.events.timer_out);						
								this.events.timer_out 	= null;
								const timer = setTimeout(()=>{

			  						this.center 			= L.latLng(this.events.lat, this.events.long);
			  						this.zoom  				= this.events.zoom_out;				
			  						this.actions("refresh_cluster");
									// this.$refs['clusterRef' + this.layout_id].mapObject.refreshClusters();
									const idx 				= this.events.array_devices.findIndex(x => (x == this.events.current.deviceId));
									if (idx >= 0) {
										this.events.array_devices.splice(idx,1)
									}
									this.render_event_alert(message);
								},1000 * this.events.time_short);
		  					}
		  				}
						
			    		
					}else{
						if (this.events.current && !this.events.array_devices.includes(message.deviceId))  {			    			
			    			this.events.array_devices.push(message.deviceId);
			    			this.events.array.push(message);
			    		}
			    		// console.log("case 2 short_event")
					}
				}
		    }, // short event

		    render_event_alert(message){
		    	let ev = this;
		    	// console.log("Alert =======================", message.deviceId)
		    	if (ev.alert_bus) {      				      		
		    		//  set latitude & longitude
	      			let lat = null, long = null;
	      			if (message && message.longitude && message.latitude && (message.latitude != 0 || message.latitude != "0") && (message.longitude != 0 || message.longitude != "0")) {
	      				lat 	= parseFloat(message.latitude);
	      				long 	= parseFloat(message.longitude);
	      			}					

	      			// search device in case not exist
					let idx =  ev.marker_static.findIndex( x => (x && x.deviceId == message.deviceId));
					if (idx >= 0) {
						if (!lat && !long) { 
							if (ev.marker_static[idx].latln && ev.marker_static[idx].latln.lat && ev.marker_static[idx].latln.lng) {
								lat  = ev.marker_static[idx].latln.lat;
								long = ev.marker_static[idx].latln.lng;
							}
						}
					}	

					// 		
					if (lat && long ) {
						long 				= this.check_long(long);
						this.events.lat 	= lat;
						this.events.long 	= long;
						this.events.current = message;
						
						// ev.list_bouncing.push({lat, long});
						
						
							// zoom map
						ev.marker_bounce1(lat, long, idx, message);
						this.actions("refresh_cluster");
						// this.$refs['clusterRef' + this.layout_id].mapObject.refreshClusters();

						// this.$refs['clusterRef' + this.layout_id].mapObject
						/*if (ev.list_bouncing && ev.list_bouncing.length > 1 && false) {
							// back to list all bounds
							ev.render_bounds();
						}else{*/
							if (this.events && this.events.array.length > 0) {
								// ev.render_bounds();
								if (this.list_bouncing_ && this.list_bouncing_.length > 0) {								
									this.list_bouncing_.shift();
								}
								ev.list_bouncing_.push( L.latLng(lat, long))
								let markerBounds = L.latLngBounds(ev.list_bouncing_);
								this.map.fitBounds(markerBounds) ;						
							}else{								
								ev.center = L.latLng(lat, long);
								ev.zoom   = this.info_option.zoom_in || 15 ; // + 5
							}

						// }
						
					}
					// redirect alert firts time
					if (this.first_event_device) {
	      				this.first_event_device = false;	      				
	      				const timer = setTimeout(()=>{
							if (this.events && this.events.array.length == 0) {	
		      					ev.marker_bounce1(lat, long, idx, message);	      					
								ev.center = L.latLng(lat, long);
								ev.zoom   = this.info_option.zoom_in || 15 ; // + 5							
							}
	      				}, 800)
	      			}
	      			if (this.events) {
	      				const time = this.info_option.time_zoom_out;
	      				this.events.timer_out = setTimeout(()=>{      												
	      					ev.zoom  	=  this.events.zoom_out;							
	      					this.render_bounds();
	      					clearTimeout(this.events.timer_out);
	      					this.events.timer_out = null;
	      					// console.log("zoom_out, ", this.events.zoom_out)
	      					this.actions("refresh_cluster");
							// this.$refs['clusterRef' + this.layout_id].mapObject.refreshClusters();
							if (this.events.array && this.events.array.length > 0) {
								this.render_event_alert(this.events.array.shift());
								// console.log("list_bouncing ", this.list_bouncing_)

								this.events.current = null;
								// this.events.lat 	= null;
								// this.events.long 	= null;

							}else{
								this.events.is_shorting = false;
								this.events.current 	= null;								
								this.events.array_devices.findIndex(x => (x == message.deviceId));
								if (idx >= 0) {
									this.events.array_devices.splice(idx,1)
								}
							}
							
	      				}, 1000 * time);
	      			}
      			} // alert bus
		    }, // render event alert

		    doZoom(zoomm){
	      		const time = this.info_option.time_zoom_out;
	      		this.zoom  = zoomm;
	      		if (this.do_zoom.timer) {
	      			clearTimeout(this.do_zoom.timer);
	      			this.do_zoom.timer = null;
	      		}
		    	this.do_zoom.timer = setTimeout(()=>{
		    		this.render_bounds();
		    		this.actions("refresh_cluster");
					this.$refs['clusterRef' + this.layout_id].mapObject.refreshClusters();
	      			clearTimeout(this.do_zoom.timer);
	      			this.do_zoom.timer = null;
		    	}, time * 1000)

		    }, // doZoom

		    marker_bounce1(lat, long, idx, item){
		    	let ev 	 		= this;		    	
		    	let is_mark_bnc = false;
		    	let icon 		= this.icon_selected;
		    	let temp_latln 	= null;
		    			
		    	let ref_temp = 'lmarker' + idx + ev.layout_id;		    	
		    	if (idx >= 0) {
		    		ev.marker_static[idx].info_alert = item; 		
		    		if (ev.marker_static[idx] && ev.marker_static[idx].marker && ev.marker_static[idx].timer) {		    				
		    			clearTimeout(ev.marker_static[idx].timer);
		    		}
		    		// set icon
		    		if(ev.marker_static[idx]){
						// console.log("current zoom bounce1 ", this.map._zoom)

						if (!this.events.is_shorting) {
		    				ev.marker_static[idx].icon = icon;
		    			}
		    		}		    		
		    	}else{
		    		is_mark_bnc 			= true;
		    	}
		    	
		    	if (ev.$refs[ref_temp] && ev.$refs[ref_temp][0] && ev.$refs[ref_temp][0].mapObject) {
		    		const timer = setTimeout(()=>{
		    			// open popup
		    			ev.$refs[ref_temp][0].mapObject.openPopup();	
		    			clearTimeout(timer);
		    		}, 100)    					
				}
				
				const timer = setTimeout(() => {
					if (idx >= 0 ) {
						// set state stream
		    			ev.set_state_stream(idx, 2);		    			
		    			ev.$nextTick(()=>{	
		    				// close popup	    				 				
		    				ev.render_popup(ev.marker_static[idx], idx);	    					
		    			})	
					}
					clearTimeout(timer);
				}, 1000);
				
				// set func timer of marker
				if (idx >= 0) {
					ev.marker_static[idx].timer = timer;
				}
		    }, // marker bounce 1

		    marker_bounce(lat, long, idx, item){		    	
		    	let ev 	 		= this;		    	
		    	let is_mark_bnc = false;
		    	let icon 		= this.icon_selected;
		    	let temp_latln 	= null;
		    	let location 	= {
		    		latitude  : lat,
		    		longitude : long,
		    		zoom 	  : 15, 
		    	}		    		
		    	let ref_temp = 'lmarker' + idx + ev.layout_id;
		    	
		    	if (idx >= 0) {
		    		ev.marker_static[idx].info_alert = item; 		

		    		// check if content timer & marker    	
		    		if (ev.marker_static[idx] && ev.marker_static[idx].marker && ev.marker_static.timer) {		    				
		    			clearTimeout(ev.marker_static[idx].timer);
		    			
		    		}

		    		// set icon
		    		if(ev.marker_static[idx]){
		    			ev.marker_static[idx].icon = icon;
		    		}
		    		if (ev.$refs[ref_temp] ){
		    			// ev.$refs[ref_temp][0].mapObject.bounce();
		    		}
		    		
		    	}
		    	else{
		    		is_mark_bnc 			= true;
		    		// console.log("bounce 3")
		    		// ev.mark_bounce.marker 	= L.marker([lat, long], {icon}).addTo(ev.map);
					// ev.mark_bounce.marker.bounce(ev.mark_bounce.num_bounce);
		    	}
		    	// console.log("REF ", ev.$refs[ref_temp][0].mapObject)
		    	// check map object
		    	if (ev.$refs[ref_temp] && ev.$refs[ref_temp][0] && ev.$refs[ref_temp][0].mapObject) {
		    		// ev.$refs[ref_temp][0].mapObject.stopBouncing();		
		    		const timer = setTimeout(()=>{
		    			// open popup
		    			ev.$refs[ref_temp][0].mapObject.openPopup();	
		    			clearTimeout(timer);
		    		}, 500)    					
				}
				// console.log("ev.$refs[ref_temp][0].mapObject : ", ev.$refs[ref_temp][0].mapObject)
				//  timer to close popup & zoom out
				const timer = setTimeout(() => {
					if (idx >= 0 ) {
						// set state stream
		    			ev.set_state_stream(idx, 2);		    			
		    			ev.$nextTick(()=>{	
		    				// close popup	    				 				
		    				ev.render_popup(ev.marker_static[idx], idx);	    					
		    			})
		    			
					}
					// ev.list_bouncing.shift();
					// ev.list_bouncing_.shift();

					// clear marker
					/*if (is_mark_bnc) {						
						// ev.map.removeLayer(ev.mark_bounce.marker);
						ev.mark_bounce.marker 		= null;
					}*/
					clearTimeout(timer);
				}, 1000 * ev.mark_bounce.timer);
				
				// set func timer of marker
				if (idx >= 0) {
					ev.marker_static[idx].timer = timer;
				}
		    }, // marker bounce
			
			render_popup(dev, idx){
				let vm = this; 
				this.streaming_active.deviceId = dev.deviceId;
				let ref_temp = 'lmarker' + idx + this.layout_id;
				vm.$refs[ref_temp][0].mapObject.getPopup().on('remove', vm.streaming_active.close = function() {
				    //Your code here
				    vm.streaming_active.deviceId = "";
				    vm.$refs[ref_temp][0].mapObject.getPopup().off('remove', vm.streaming_active.close);				    
				});
			}, // render popup

		    geo_location(){
		    	let ev = this;
		    	if ("geolocation" in navigator) {
		      		navigator.geolocation.getCurrentPosition(function(position) {
				  
				        ev.geolocation.latitude 	= position.coords.latitude;
				        ev.geolocation.longitude 	= position.coords.longitude;
				        if (ev.$route.name == 'setting_device' && !ev.is_marked) {
				        	const timer = setTimeout(()=>{

					        	ev.marker = L.latLng(position.coords.latitude, position.coords.longitude);
								ev.center = L.latLng(position.coords.latitude, position.coords.longitude);
								ev.maker_fit.push(L.latLng(position.coords.latitude, position.coords.longitude));
								ev.render_bounds();

								ev.onResize();
								clearTimeout(timer);
				        	}, 2000)
				        	

				        }
				    });
		      	}else{
		      		console.log("geolocation its Not  enable")
		      	}
		    }, // geo location

		    check_device_workstation(item){
		    	let check 		= false	
		    	if (item) {
		    		let device_id 	= item.deviceId || item.hostId; 
		    		let manager_id 	= item.manager_id;
		    		if (this.multiples.devices.includes(device_id) || this.multiples.devices.includes("all")) {
		    			check = true;
		    		}
		    		/*if (this.multiples.workstations.includes(manager_id) || this.multiples.workstations.includes("all")) { // this.multiples.devices_workstations.includes(device_id)
		    			check = true;
		    		}else
		    		if (this.multiples.workstations.includes("my_computer") && !manager_id) {
		    			check = true;
		    		}*/
		    		if (this.is_modal) {
		    			check = true;
		    		}
		    	}
		    	return check
		    }, // check device workstation|

		    update_component_map(event, device, idx){
		    	// console.log("Event ", event , device)
		    	if (event && device) {
		    		if (!this.info_map_devices[device.deviceId]) {
		    			this.info_map_devices[device.deviceId] = {};
		    		}
		    		this.info_map_devices[device.deviceId].channel = event.value;
		    		if (idx >= 0) {
		    			this.marker_static[idx].channel = event.value;
		    		}
		    		this.actions("update_component");

		    	}

		    }, // update_component_map
		    render_map_gps_workstations(){
		    	if (this.bus) {
		    		for(const name in this.bus){
		    			if (name.includes('states_workspace_')) {
		    				EventBus.$off(name, this.bus[name]); // clear bus actives
		    			}
		    		}
		    	}
		    	if (this.multiples ) {
			    	if (this.multiples.workstations && this.multiples.workstations.length > 0) {
			    		this.multiples.workstations.forEach((it)=>{
			    			if (!it.includes("all")) {

					    		console.log("workstations ", it)
						    	let temp = 'states_workspace_' + it;
								EventBus.$on(temp, this.bus[temp] = (msg)=>{
									// console.log("workstations MSG ",  msg)
									if (msg) {
																
										if (msg.latitude && msg.longitude) {							
											const idx = this.marker_static.findIndex(x => x && x.manager_id == msg.manager_id);
											if (idx >= 0) {										
												const long 							= this.check_long(msg.longitude);
												this.marker_static[idx].latln 		= L.latLng(msg.latitude, long);
											}else{
												const long 	= this.check_long(msg.longitude)
												const temp 	= this.format_workstation({...msg}, long);
												this.maker_fit.push(L.latLng(msg.latitude, long))
												this.marker_static.push(temp);
												this.render_bounds();

												// }
											}
										}
										
									}
								}); // bus
			    			} 
				    	}); 
			    	}
		    	}
			}, // render_map_gps_workstations

			render_len_icon_options(item){
				// console.log("CHECK RENDER LEN Map icon ", item)
				if (item && this.multiples && this.multiples[item] && this.multiples[item].length) {
					return this.multiples[item].length
				}
				return 0;
			}, // render_len_icon_options

			render_names_multiples_map(items, key){				
				let temp = [];				
				if (items) {	
					if (key == "devices") {						
						this.$store.getters['Devices/list_options'].forEach((it)=>{ 
							if (items.includes(it.deviceId)){ 
								temp.push(it.name); 
							} 
						});						
					}else if (key == "workstations"){
						this.$store.getters['Workspaces/list_options'].forEach(it => {
							if(items.includes(it.manager_id)){ 
								temp.push(it.name)
							}
						});						
					}else{
						temp = items;
					}
				}
				return temp;


			}, // render_names_multiples_map

			renderEventStatus(action){
				let ev = this;
				let idx   		= ev.marker_static.findIndex( x => (x && x.deviceId == action.deviceId));
				let temp_state 	= 0;		
				// console.log("FIND Device status ", idx, ev.marker_static  )			
				if (idx >= 0) {
					if (ev.marker_static[idx]) {
      						// console.log("check technial ", action, ev.marker_static[idx])
						if (action.code.includes("BK_RTSP_")) {
							if (action.state == 0) {
								temp_state = 1;
							}
							if(ev.marker_static[idx].workspace && ev.marker_static[idx].workspace != 'my_computer' && 
								action.code.includes("BK_RETRASMISSION_LOCAL")){
								if (action.state == 0) {
									temp_state = 1;
								}
							}
							if (temp_state != ev.marker_static[idx].state){
								ev.set_state_stream(idx, temp_state);
							}
						}
					}
				}
			}, // render event status

			renderValidSmartEvent(item){
				if(this.listSmartEvents && this.listSmartEvents.length && item?.ruleId){
					const find = this.listSmartEvents.find(x=>x.id == item.ruleId)
					if(find){
						if (find?.actions) {
							return find?.actions?.ismodal;
						}
					}
				}
				return false
			},


		}, // methods

		mounted() {			
			// this.render_map_gps_workstations();
			this.onResize();
      		// this.$nextTick(() => {
       		 // 		this.$refs.myMap.mapObject.ANY_LEAFLET_MAP_METHOD();
      		// });
      		let ev 	 	  = this;
      		let cont 	  = 0;
    
      		let temp_last = this.$Helper.get_local('last_coord_map');
      		if (temp_last) {
      			ev.marker = L.latLng(temp_last.latitude, temp_last.longitude);
				ev.center = L.latLng(temp_last.latitude, temp_last.longitude);	
				ev.maker_fit.push(L.latLng(temp_last.latitude, temp_last.longitude));
				ev.render_bounds();
				this.onResize();
      		}


	      	EventBus.$on("event_gps", this.bus.event_gps = (message) => {
      			if (ev.gps_active) {      			
      				if (message && message.longitude && message.latitude && (message.longitude != 0 || message.longitude != "0") && (message.latitude != 0 || message.latitude != "0")) {

		      			ev.marker = L.latLng(message.latitude, message.longitude);
						ev.center = L.latLng(message.latitude, message.longitude);
						ev.zoom   = this.info_option.zoom_in || 15;

						// save last coords every 5 events
						if (cont == 5) {
							cont = 0;
							this.$Helper.set_local('last_coord_map', {
								latitude  : message.latitude,
								longitude : message.longitude
	  						});
						}
      				}
					cont ++;
      			}
	      	});
	      	let int = true;	     

	      	// connection alerts 	      	
	      	EventBus.$on("events_alerts_map", this.bus["events_alerts_map"] = (message) => {
	      		if (this.check_device_workstation(message) && this.mode_active !== 'workstations') {
	      			if(this.renderValidSmartEvent(message)){
	      				this.event_alert(message); // this.info_option.zoom_in || 15
	      			}
	      		}
	      	});

	      	
	      	EventBus.$on('events_technical',  this.bus['events_technical'] = (action) => {
	      		if (ev.alert_bus && action) {					
	      			this.renderEventStatus(action);
	      		}
	      	});
	      	EventBus.$on('events_technical_mapview',  this.bus['events_technical_mapview'] = (action) => {
	      		if (ev.alert_bus && action) {						      				      		
	      			this.renderEventStatus(action);
	      		}
	      	})
	      	

	      	/*EventBus.$on('status_analytic',  this.bus['status_analytic'] = (action) => {
				if (ev.alert_bus && action) {					
					let idx   		= ev.marker_static.findIndex( x => (x && x.deviceId == action.deviceId));
					let temp_state 	= null;					
					if (idx >= 0) {
						if (ev.marker_static[idx].deviceId == action.deviceId) {
							if (action.statusStreaming) 
							{										
								temp_state = 1;
							}
							else
							{
								temp_state = 0;
							}
							
							if (temp_state != ev.marker_static[idx].state) 
							{
								ev.set_state_stream(idx, temp_state);
							}
						}
							
					}

					
				}
			});*/

	      	this.geo_location();

    	},// mounted

    	beforeDestroy(){
    		EventBus.$emit('close_gps', this.gps_active );
    		this.clear_map();
    		this.$Helper.clear_bus(EventBus, this.bus, 'mapview')
    		
  		}, // beforeDestroy

	}; // export